import {
  subjectOfVariableType,
  type TemplateVariable,
} from "@/shared/domain/agents";
import { type LaunchSeed } from "@/shared/domain/agents/launchSubject";

/**
 * The values a launch opens on: each id the launch link carries, on every
 * variable whose type takes that kind of id (`?dataset_id` on DATASET_ID
 * variables, `?session_id` on SESSION_ID variables), and nothing else.
 * Declared defaults are not copied: an untouched variable is absent from the
 * request and the server substitutes its default.
 */
export function seedLaunchValues(
  variables: readonly TemplateVariable[],
  seed: LaunchSeed,
): Record<string, string> {
  return Object.fromEntries(
    variables.flatMap((variable) => {
      const kind = subjectOfVariableType(variable.type);
      const id = kind === undefined ? undefined : seed[kind];
      return id ? [[variable.name, id] as const] : [];
    }),
  );
}
